import apiClient from "@/api/client";

export default {
  fetchTypes() {
    return apiClient.get("/types");
  },
};
